import React from "react";
import {
  Box,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
} from "@mui/material";

interface AccessibilityOptionsProps {
  selectedAccessibility: string;
  onChange: (value: string) => void;
}

const AccessibilityOptions: React.FC<AccessibilityOptionsProps> = ({
  selectedAccessibility,
  onChange,
}) => {
  return (
    <Box
      sx={{ px: "4%", py: "1%", bgcolor: "#f8f9fa", borderRadius: 2, mt: "2%" }}
    >
      <Typography
        variant="h6"
        sx={{
          color: "#313131",
          fontSize: { xs: "3.64vw", sm: 15 },
          mb: "3%",
          fontWeight: 700,
        }}
      >
        Accessibility Status
      </Typography>
      <FormControl component="fieldset" fullWidth>
        <RadioGroup
          aria-label="accessibility-status"
          name="accessibility-status"
          value={selectedAccessibility}
          onChange={(e) => onChange(e.target.value)}
        >
          {[
            "All",
            "Fully Accessible",
            "Partially Accessible",
            "Not Accessible",
          ].map((option) => (
            <FormControlLabel
              key={option}
              value={option.toLocaleLowerCase().replace(" ", "_")}
              control={
                <Radio
                  sx={{
                    color: "#626262",
                    "&.Mui-checked": { color: "#9443DF" },
                  }}
                />
              }
              label={
                <Typography
                  sx={{
                    fontSize: { xs: "3.4vw", sm: 14 },
                    fontWeight: 500,
                    color: "#333",
                  }}
                >
                  {option}
                </Typography>
              }
            />
          ))}
        </RadioGroup>
      </FormControl>
    </Box>
  );
};

export default AccessibilityOptions;
